const RU = {
    mask: '+{7} (#00) 000-00-00',
    definitions: {
        '#': /[9]/
    }
};
const International = {
    mask: '+0000000000000'
};
export const Mask = {
    RU,
    International
};
